import { SearchResultPlan, PlanResults } from "../@types";
import searchResultPlan from "./searchResultPlan";

const plans: SearchResultPlan[] = [];
for (let i = 0; i < 3; i++) {
  const searchResult = searchResultPlan({ id: i });
  plans.push(searchResult);
}

const defaultReturn = {
  plans,
  request_id: "1",
  total_results: 3,
  search_summary: {
    dental: 3,
    drugs: 3,
    excluded: 3,
    hearing: 3,
    national: 3,
    no_drugs: 3,
    organization_names: ["Those Guys, Inc."],
    vision: 3,
    sanctioned: 0,
    categories: {
      hmo: 6,
      ppo: 2,
      pffs: 0,
      msa: 1,
      cost: 0,
    },
    senior_savings_model: 7,
  },
};

export function getANumberOfPlans(quantity: number): PlanResults {
  const plans: SearchResultPlan[] = [];
  for (let i = 0; i < quantity; i++) {
    const searchResult = searchResultPlan({ id: i });
    plans.push(searchResult);
  }
  return { ...defaultReturn, plans, total_results: quantity };
}

export default defaultReturn;
